import { TFunction } from 'i18next';
import { ExternalChartComponentProps } from '../../data-viz-containers/common/types';
import {
  TimePeriodSegmentedViz,
  TimePeriodSegmentedVizProps,
} from '../../data-viz-containers/time-period-segmented/TimePeriodSegmentedViz';
import {
  StoryboardComponentIds,
  StoryboardComponentSettings,
} from '../common/types';
import { TimePeriodSegmentedStoryboardComponentConfig } from './types';

const componentConfigToVizContainerProps = (
  componentConfig: TimePeriodSegmentedStoryboardComponentConfig,
  externalProps: ExternalChartComponentProps,
  persistenceKey: string
) => {
  return {
    dataConfig: componentConfig.dataConfig,
    selectedView: componentConfig.selectedView,
    externalProps: externalProps,
    persistenceKey: persistenceKey,
  };
};

export const timePeriodSegmentedStoryboardComponentSettings: StoryboardComponentSettings<
  TimePeriodSegmentedStoryboardComponentConfig,
  TimePeriodSegmentedVizProps
> = {
  componentId: StoryboardComponentIds.TIME_PERIOD_SEGMENTED,
  componentConfigToVizContainerProps: componentConfigToVizContainerProps,
  VizContainerComponent: TimePeriodSegmentedViz,
  validateConfig: (componentConfig, t: TFunction) => {
    return {
      isValid: true,
      error: null,
    };
  },
};
